/* tslint:disable */
/* eslint-disable */
export enum AttachmentEntityClass {
  BulkPrintRequest = 'BulkPrintRequest',
  FormQualityEntry = 'FormQualityEntry',
  FormRiskEntry = 'FormRiskEntry',
  FormSnapshotRequest = 'FormSnapshotRequest',
  FormCustom = 'FormCustom',
}
